/**
 * #10253 — Exclusion check entry / roster readiness.
 * Name is required; NPI, SSN, and License # are optional (name-only lookup).
 * AB#10169 — When NPI is provided, it must be exactly 10 digits.
 */
import { isValidAdverseCheckName } from "./adverseCheckName";

/** True when row has at least one of NPI / SSN / License # (informational only). */
export function hasAdverseCheckIdentifier(user: {
  npi?: string;
  ssn?: string;
  licenses?: Array<{ number: string }>;
}): boolean {
  if (String(user.npi || "").trim()) return true;
  if (String(user.ssn || "").trim()) return true;
  if (user.licenses?.some((l) => String(l.number || "").trim())) return true;
  return false;
}

/** Empty NPI is allowed; non-empty must be exactly 10 digits. */
export function isValidOptionalAdverseCheckNpi(npi?: string): boolean {
  const trimmed = String(npi || "").trim();
  if (!trimmed) return true;
  return /^\d{10}$/.test(trimmed);
}

export const ADVERSE_CHECK_NPI_HELPER =
  "NPI must be exactly 10 digits when provided";

/** Single-entry form: valid name enables Run check; non-empty NPI must be 10 digits. */
export function isAdverseCheckEntryValid(options: {
  isEntitySearch: boolean;
  entityName: string;
  lastName: string;
  npi?: string;
}): boolean {
  const nameOk = options.isEntitySearch
    ? isValidAdverseCheckName(options.entityName)
    : isValidAdverseCheckName(options.lastName);
  if (!nameOk) return false;
  return isValidOptionalAdverseCheckNpi(options.npi);
}

/** Roster / Affable row ready when name is present (identifiers optional). */
export function isRosterRowReady(user: { name?: string | null }): boolean {
  return Boolean(String(user.name || "").trim());
}
